import { useMutation } from '@tanstack/react-query'

import { registerNote } from '@src/api'
import { DefaultApiRegisterNoteRequest } from '@src/api/generated/user-api'
import { useAxios } from '@src/hooks/use-axios'

export const useRegisterNote = () => {
  const { axiosInstance } = useAxios()

  return useMutation({
    mutationFn: (params: DefaultApiRegisterNoteRequest) =>
      registerNote(axiosInstance, params),
  })
}
